<div class="widget" [class.loading-widget]="loading" [class.widget--no-data]="noData" >
  <span class="widget__title" *ngIf="!isInPopup">
     <span>{{'Cost Per Ton' | translate | async}}</span> 
    <i class="material-icons" [matTooltip]="'Cost Per Ton' | translate | async | translate | async">info</i>
     <!-- <i class="material-icons" [matTooltip]="'Enlarge ' | translate | async | translate | async" (click)="openWithANewPopup()">zoom_in</i>  -->
  </span>
  <!-- <div class="widget__content"> -->
 <div [ngClass]="{'widget__content' : !isInPopup , 'large-widget' : isInPopup}">
    <!-- <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div> -->
    <fusioncharts  *ngIf="!loading" [hidden]="loading"   [width]="width" [height]="height" [type]="type" [dataFormat]="dataFormat"
      [dataSource]="dataSource">
    </fusioncharts>
    
  </div> 
  <div class="widget__no-data" *ngIf="noData">
    <span>{{'You haven\'t selected customer.' | translate | async}}</span>
  </div> 
</div>